export default __webpack_public_path__ + "canli.svg";